/* global http preloader */
const submitFileUploader = {
	el: {
		inputFile: document.querySelectorAll('input[type=file]')
	},

	vars: {
		invalidMessage: document.querySelectorAll('.js-form')[0] && document.querySelectorAll('.js-form')[0].dataset.msgInvalidFormat,
		limitMessage: document.querySelectorAll('.js-form')[0] && document.querySelectorAll('.js-form')[0].dataset.msgLimit
	},

	fxFileUploader(e) {
		document.querySelectorAll('.js-clear-file').forEach(el => el.style.display = 'none')
		e.stopPropagation()

		const el = e.currentTarget,
			formData = new FormData(),
			limitUploadSize = el.dataset.limit, //bytes
			fileValue = el.previousElementSibling.previousElementSibling,
			fileName = el.nextElementSibling,
			filePlaceholder = el.previousElementSibling,
			fileClearBtn = el.nextElementSibling.nextElementSibling,
			fileError = el.closest('.form__field-upload-file').nextElementSibling

		formData.append('file', el.files[0])

		if (el.files[0].size > 0 && el.files[0].size < limitUploadSize) {
			const extension = `.${el.value.toLowerCase().split('.').pop()}`
			let validExtension = false

			el.getAttribute('accept').split(',').forEach(ext => ext === extension ? validExtension = true : '')

			if (validExtension) {
				preloader.fxPreloaderAdd(el.previousElementSibling)

				const callback = (response, data) => {
					preloader.fxPreloaderRemove(el.previousElementSibling)
					
					if (response.status === 200) {
						el.nextElementSibling.classList.contains('field-error') && el.nextElementSibling.remove()
						fileClearBtn.style.display = 'inherit'
						fileValue.value = data
						filePlaceholder.style.display = 'none'
						fileName.style.display = 'flex'
						fileName.textContent = ''
						fileName.textContent = el.files[0].name
						fileError.classList.remove('field-error')
						fileError.textContent = ''

						fileClearBtn.addEventListener('click', () => {
							fileClearBtn.style.display = 'none'
							el.value = ''
							fileValue.value = ''
							fileName.style.display = 'none'
							fileName.textContent = ''
							filePlaceholder.style.display = 'flex'
							setTimeout(() => el.style.display = 'none', 0)
						})
					}
				}

				http.fxUploadFile(el.dataset.endpoint, formData, callback)
			}
			else {
				console.log(fileError)
				fileError.textContent = `${this.vars.invalidMessage}`
				fileError.classList.add('form__error-message')
				fileClearBtn.style.display = 'none'
			}
		}
		else {
			fileClearBtn.style.display = 'none'
			const bytesToMegaBytes = bytes => bytes / (1024 * 1024)
			fileError.textContent = `${this.vars.limitMessage} ${Math.round(bytesToMegaBytes(limitUploadSize))} MB`
			fileError.classList.add('form__error-message')
		}
	},

	events() {
		this.el.inputFile.forEach(el => el.addEventListener('change', e => this.fxFileUploader(e)))
	},

	init() {
		this.events()
	}
}

submitFileUploader.init()